import React, { useState, useEffect } from 'react'
import StyledButton from '../../generic/StyledButton'
import DraggableModal from '../../generic/DraggableModal'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { backendPatchWithoutRefresh } from '../../../helpers/callBackend'

const DebitFailureModal = ({ visible, handleCancelModal, paymentRequest, failureObject, updatePaymentRequests }) => {
  const [senderName, setSenderName] = useState(
    paymentRequest.sender_name ? paymentRequest.sender_name : 'this bank account'
  )
  const [counterPartyName, setCounterPartyName] = useState(
    paymentRequest.counterparty_name ? paymentRequest.counterparty_name : 'Unknown'
  )
  const [returnCode, setReturnCode] = useState(failureObject.code ? failureObject.code : 'Unknown')
  const [returnReason, setReturnReason] = useState(failureObject.description ? failureObject.description : 'Unknown')
  const cancelRequest = async () => {
    try {
      const cancelResp = await backendPatchWithoutRefresh('/api/payments/payment-request/', {
        cancel: true,
        payment_request_id: paymentRequest.id,
      })
      updatePaymentRequests(cancelResp.data?.data, "remove")
    } catch (error) {
      console.error(error)
    }
    handleCancelModal(false)
  }
  useEffect(() => {
    setSenderName(paymentRequest.sender_name ? paymentRequest.sender_name : 'this bank account')
    setCounterPartyName(paymentRequest.counterparty_name ? paymentRequest.counterparty_name : 'Unknown')
    setReturnCode(failureObject.code ? failureObject.code : 'Unknown')
    setReturnReason(failureObject.description ? failureObject.description : 'Unknown')
  }, [paymentRequest, failureObject])
  return (
    <DraggableModal
      modalTitle='Returned Payment'
      modalVisible={visible}
      handleCancelModal={handleCancelModal}
      content={
        <Stack spacing={2} fullWidth>
          <Typography>{`The payment to ${counterPartyName} from ${senderName} was returned. Your account could not be debited.`}</Typography>
          <Typography>{`Return Code: ${returnCode} ${returnReason}`}</Typography>
          <Typography>
            By clicking "Clear Alert" below, this transactions will be removed from processing. You will need to create
            a new payment if you'd like to attempt to send this payment again.
          </Typography>
        </Stack>
      }
      actions={<StyledButton label='Clear alert' fontSize={14} onClick={cancelRequest} />}
    />
  )
}

export default DebitFailureModal
